import React, { useState } from "react";
import {
  Box,
  TextField,
  Autocomplete,
} from "@mui/material";
import BaseDrawer from "../../UI/BaseDrawer/BaseDrawer";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { SendEmailWithFrom } from "../../../util/API/admin";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { useSelector } from "react-redux";

function Support({ open, handleCloseModal }) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "error",
    header: "Error",
    message: "",
  });

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  let configVariables = useSelector((state) => state.config.baseConfig);

  const subjects = [
    "Questions about My Account",
    "Mobile App Assistance",
    "Improvements / Suggestions",
  ];

  const handleSubmit = async () => {
    const response = await SendEmailWithFrom(
      agent['Useremailaccount'].emailAccount,
      subject,
      message
    )

    if (response?.callStatus === "1") {
      setAlert({
        ...alert,
        showAlert: true,
        severity: "success",
        header: "Success",
        message: "Support Email sent successfully",
      })
    }

    else {
      setAlert({
        ...alert,
        showAlert: true,
        severity: "error",
        header: "Error",
        message: response?.msg
      })


    };
  }

  return (
    <BaseDrawer
      open={open}
      handleClose={handleCloseModal}
      height="80vh"
      title="Support"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 0, // Remove extra padding from BaseDrawer
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Push content to the top
          gap: 3,
          padding: 0,
          margin: 0,
          height: "100%",
        }}
      >
       <TextField
          label="To"
          value={configVariables?.supportEmail}
          disabled
          variant="outlined"
          InputProps={{
            readOnly: true, // Makes the field non-editable
            sx: { backgroundColor: "white" }, // White background inside the input
          }}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            width: "60%", // Reduced width
            minWidth: "300px",
          }}
        />

        {/* Subject Dropdown with Autocomplete */}
        <Autocomplete
          options={subjects}
          getOptionLabel={(option) => option}
          value={subject}
          onChange={(event, newValue) => setSubject(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Subject"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                sx: { backgroundColor: "white" }, // White background
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          sx={{
            width: "60%", // Reduced width
            minWidth: "300px",
          }}
        />

        {/* Message Input */}
        <TextField
          label="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          multiline
          rows={5}
          variant="outlined"
          InputProps={{
            sx: { backgroundColor: "white" }, // White background
          }}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            width: "60%", // Reduced width
            minWidth: "300px",
          }}
        />

        {/* Submit Button */}
        <BaseButton onClick={handleSubmit} buttonText="Submit" />
      </Box>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {setAlert({ ...alert, showAlert: false }); handleCloseModal();}}
        autoclose={alert.severity === "error" ? false : true}
      />
    </BaseDrawer>
  );
}

export default Support;
